import {
	LoginWithDialogContainer,
	NewLoginFlowGuard,
	PostLoginFlowInitGuard,
	VerificationSgaLoginWithDialogContainer,
} from "@obg/common.login";
import { ArgentinaGeofencingGuard } from "@obg/ngx.common";
import { AuthAnonymousGuard, CORE_ROUTE, ProductType } from "@obg/ngx.core";
import { RouteConfig } from "@obg/ngx.router";

import { CoreLayoutContainer } from "./layouts/core-layout/core-layout.container";

export const CORE_ROUTES_CONFIG: RouteConfig[] = [
	{
		name: CORE_ROUTE.auth.login,
		path: "login",
		component: LoginWithDialogContainer,
		layout: CoreLayoutContainer,
		data: {
			product: ProductType.Common,
			openDialog: true,
		},
		canActivate: [AuthAnonymousGuard, ArgentinaGeofencingGuard, PostLoginFlowInitGuard, NewLoginFlowGuard],
	},
	{
		name: CORE_ROUTE.auth.bankIdVerification,
		path: "bank-id-verification",
		component: VerificationSgaLoginWithDialogContainer,
		layout: CoreLayoutContainer,
		data: {
			product: ProductType.Common,
			openDialog: true,
		},
		canActivate: [PostLoginFlowInitGuard],
	},
];
